import {
  SENDLANE_API_KEY,
  SENDLANE_API_KEYS,
  SENDLANE_LISTS,
} from '@mm/api-routes';
import AuthenticatedController from './AuthenticatedController';

export default class SendlaneController extends AuthenticatedController {
  static async getLists(
    facebookPageId: number,
    accessTokenId: number,
    force: boolean,
  ) {
    return super.get(SENDLANE_LISTS, {
      facebook_page_id: facebookPageId,
      token_id: accessTokenId,
      force,
    });
  }

  static async getApiKeys(facebokPageId: number) {
    return super.get(SENDLANE_API_KEYS, {
      facebook_page_id: facebokPageId,
    });
  }

  static async createApiKey(privateKey: string) {
    return super.post(SENDLANE_API_KEYS, { privateKey });
  }

  static async updateApiKey(id: number, privateKey: string) {
    return super.put(SENDLANE_API_KEY(id), { privateKey });
  }
}
